module.exports = __webpack_public_path__ + "img/NeiBuXieTiao.36af263e.png";